<template>
    <div class="chat-style-search-row">
        <div class="chat-search-center-wrapper">
            <div class="chat-search-input-container">
                <div class="chat-search-icon-wrapper">
                    <i class="bx bx-search"></i>
                </div>
                <input type="text" class="chat-normal-search-input"
    :placeholder="chat.active_leads_book ? getTranslations('expression_60') : getTranslations('expression_60')"
    v-model="searchQuery"
    @keyup.enter="handleSearch" />


                <div v-if="chat.active_leads_book ? search_lead_book : chat.search" class="chat-search-clear-button"
                    @click="clearCurrentSearch">
                    <i class="bx bx-x"></i>
                </div>
            </div>

            <!-- Botão de filtro -->
            <!-- <div class="chat-filter-button" @click="toggleFilterPopover" ref="filterButton">
                <div class="chat-filter-icon-wrapper">
                    <i class="bx bx-filter-alt"></i>
                </div>
            </div> -->
        </div>

        <!-- Popover de filtro -->
        <div v-if="isFilterOpen" class="chat-filter-popover" :style="popoverPosition">
            <div class="chat-filter-popover-arrow"></div>
            <div class="chat-filter-popover-header">
                <h3>Filtros</h3>
                <button class="chat-filter-close-button" @click="isFilterOpen = false">
                    <i class="bx bx-x"></i>
                </button>
            </div>

            <div class="chat-filter-popover-content">
                <!-- Filtro por canal -->
                <div class="chat-filter-group">
                    <label class="chat-filter-label">Canal</label>
                    <select v-model="chat.filter_search.channel_id" class="chat-filter-select"
                        :class="{ 'error': filter_errors.channel_id }">
                        <option value="0">Todos os canais</option>
                        <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                            {{ channel.name }}
                        </option>
                    </select>
                    <span v-if="filter_errors.channel_id" class="chat-filter-error">
                        {{ filter_errors.channel_id }}
                    </span>
                </div>

                <!-- Filtro por departamento -->
                <div class="chat-filter-group">
                    <label class="chat-filter-label">Departamento</label>
                    <select v-model="chat.filter_search.department_id" class="chat-filter-select"
                        :class="{ 'error': filter_errors.department_id }"
                        :disabled="chat.filter_search.channel_id == 0">
                        <option value="0">Todos os departamentos</option>
                        <option
                            v-for="department in chat.departments_available.filter(d => d.channel_id == chat.filter_search.channel_id)"
                            :key="department.id" :value="department.id">
                            {{ department.name }}
                        </option>
                    </select>
                    <span v-if="filter_errors.department_id" class="chat-filter-error">
                        {{ filter_errors.department_id }}
                    </span>
                </div>

                <!-- Filtro por tag -->
                <div class="chat-filter-group">
                    <label class="chat-filter-label">Tag</label>
                    <select v-model="chat.filter_search.tag_id" class="chat-filter-select"
                        :disabled="chat.filter_search.channel_id == 0">
                        <option value="0">Todas as tags</option>
                        <option
                            v-for="tag in chat.tags_available.filter(t => t.channel_id == chat.filter_search.channel_id)"
                            :key="tag.id" :value="tag.id">
                            {{ tag.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="chat-filter-popover-footer">
                <button class="chat-filter-button chat-filter-clear" @click="clearFilter">
                    Limpar
                </button>
                <button class="chat-filter-button chat-filter-apply" @click="applyFilter">
                    Aplicar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import no_pic from "../../assets/img/no-pic-user.png";
import $ from "jquery";
import { api } from "../../services";
import ModalAddLead from "../modals/ModalAddLead.vue";

export default {
    name: "ChatSearchInput",
    components: {
        ModalAddLead
    },
data() {
  return {
    searchDebounceTimeout: null,
    searchQuery: "", // inicia vazio
    isFilterOpen: false,
    popoverPosition: { top: '0px', right: '0px' },
    no_pic: no_pic,
    isopenModalVisible: false,
    addlead_step: 1,
    new_lead: { name: "", phone: "", email: "", channel_id: null },
    exists_error: false,
    filter_errors: { channel_id: null, department_id: null },
    search_lead_book: "",
    isSearching: false,
  };
},
  mounted() {
  this.searchQuery = this.chat.active_leads_book ? this.search_lead_book : this.chat.search;
},
  watch: {
    // Sempre sincroniza quando o Vuex for alterado externamente
    'chat.search'(newVal) {
      if (!this.chat.active_leads_book) {
        this.searchQuery = newVal;
      }
    }
  },
  methods: {
  
  

   clearCurrentSearch() {
  this.searchQuery = "";
  if (this.chat.active_leads_book) {
    this.search_lead_book = "";
    this.$store.commit("SET_LEADS_BOOK_PAGINATION", null);
    this.$store.commit("SET_LEADS_BOOK_SEARCH_RESULTS", []); 
  } else {
    this.$store.commit("SET_CHAT_SEARCH", "");
    this.$store.commit("SET_CHAT_SEARCH_RESULTS", { leads: [], histories: [] });
  }

  this.$store.commit('SET_IS_SEARCHING', false);
  this.$store.commit('SET_HAS_SEARCHED', false);
  this.isSearching = false;
},


handleSearch() {
  const search = this.searchQuery.trim();
  if (!search) {
    this.clearCurrentSearch();
    return;
  }
  
  this.$store.commit('SET_IS_SEARCHING', true);
  

 const currentStatusKey = this.$store.state.chat.filter_search.status_key;
  

  if (currentStatusKey != null) {
    this.$store.commit('SET_CHAT_SEARCH', search);
    this.$store.dispatch('searchTickets', {
      query: search,
      status_key: currentStatusKey
    }).catch(() => {
      this.$store.commit('SET_IS_SEARCHING', false);
    });
  } else {
    
    console.error("Erro: status_key não disponível para busca");
    this.$toast.error("Não foi possível realizar a busca. Por favor selecione uma aba de status.");
    this.isSearching = false;
  }

    }
  }
};
</script>

<style scoped>
/* Estilo para centralizar o componente de busca na tela */
.chat-style-search-row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 20px;
    pointer-events: none;
    /* Permite clicar através do container */
}

/* Wrapper para centralizar o input */
.chat-search-center-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
    pointer-events: auto;
    /* Restaura a interatividade apenas para o input */
    gap: 10px;
}

/* Container do input de busca */
.chat-search-input-container {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
}

.chat-search-input-container:focus-within {
    border-color: #0594e6;
    box-shadow: 0 0 0 2px rgba(69, 158, 206, 0.1);
}

.chat-search-input-container:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

/* Ícone de busca */
.chat-search-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.chat-search-icon-wrapper i {
    font-size: 18px;
    color: #6b7280;
}

/* Input de busca */
.chat-normal-search-input {
    flex: 1;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 14px;
    color: #192830;
    padding-right: 30px;
}

/* Botão de limpar */
.chat-search-clear-button {
    position: absolute;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.chat-search-clear-button i {
    font-size: 16px;
    color: #9ca3af;
    transition: color 0.2s ease;
}

.chat-search-clear-button:hover i {
    color: #0594e6;
}

/* Botão de filtro */
.chat-filter-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.chat-filter-button:hover {
    background-color: #f9fafb;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.chat-filter-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.chat-filter-icon-wrapper i {
    font-size: 18px;
    color: #6b7280;
    transition: color 0.2s ease;
}

.chat-filter-button:hover .chat-filter-icon-wrapper i {
    color: #0594e6;
}

/* Popover de filtro */
.chat-filter-popover {
    position: fixed;
    width: 300px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    overflow: hidden;
    pointer-events: auto;
    animation: popoverFadeIn 0.2s ease;
    border: 1px solid #e5e7eb;
}

@keyframes popoverFadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.chat-filter-popover-arrow {
    position: absolute;
    top: -8px;
    right: 20px;
    width: 16px;
    height: 16px;
    background-color: #fff;
    transform: rotate(45deg);
    border-left: 1px solid #e5e7eb;
    border-top: 1px solid #e5e7eb;
}

.chat-filter-popover-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid #f3f4f6;
}

.chat-filter-popover-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #111827;
}

.chat-filter-close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background-color: #f3f4f6;
    cursor: pointer;
    transition: all 0.2s ease;
}

.chat-filter-close-button:hover {
    background-color: #e5e7eb;
}

.chat-filter-close-button i {
    font-size: 16px;
    color: #6b7280;
}

.chat-filter-popover-content {
    padding: 15px 20px;
    max-height: 300px;
    overflow-y: auto;
}

.chat-filter-group {
    margin-bottom: 15px;
}

.chat-filter-label {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #4b5563;
}

.chat-filter-select {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background-color: #fff;
    font-size: 14px;
    color: #111827;
    outline: none;
    transition: all 0.2s ease;
}

.chat-filter-select:focus {
    border-color: #0594e6;
    box-shadow: 0 0 0 2px rgba(69, 158, 206, 0.1);
}

.chat-filter-select:hover {
    border-color: #d1d5db;
}

.chat-filter-select.error {
    border-color: #ef4444;
}

.chat-filter-error {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    color: #ef4444;
}

.chat-filter-popover-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 15px 20px;
    border-top: 1px solid #f3f4f6;
}

.chat-filter-button {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.chat-filter-clear {
    background-color: #fff;
    color: #6b7280;
    width: 90px;
    border: 1px solid #e5e7eb;
}

.chat-filter-clear:hover {
    background-color: #f9fafb;
    color: #4b5563;
}

.chat-filter-apply {
    background-color: #0594e6;
    color: #fff;
    width: 90px;
    border: 1px solid transparent;
}

.chat-filter-apply:hover {
    background-color: #0486d0;
}

/* Responsividade */
@media (max-width: 768px) {
    .chat-search-center-wrapper {
        max-width: 350px;
    }

    .chat-filter-popover {
        width: 280px;
    }
}

@media (max-width: 576px) {
    .chat-search-center-wrapper {
        max-width: 300px;
    }

    .chat-style-search-row {
        padding: 0 10px;
    }

    .chat-filter-popover {
        width: 250px;
    }

    .chat-filter-popover-content {
        padding: 10px 15px;
    }

    .chat-filter-popover-footer {
        padding: 10px 15px;
    }
}
</style>